export default __webpack_public_path__ + "static/media/reem-island.436d04d0.webp";